<template>
  <div class="error-panel">
    <div class="error-panel__inner-container">
      <h3>
        <slot>
          {{ displayMessage }}
        </slot>
      </h3>
      <a class="basic-link" href="mailto:opkoti@op.fi">Kysy tai anna palautetta palvelusta</a>
      <div v-if="buttonText">
        <a v-if="linkUrl" class="form-button" :href="linkUrl">
          <span>{{ buttonText }}</span>
        </a>
        <a v-else class="form-button" @click="hasHistory() ? $router.go(-1) : $router.push('/')">
          <span>{{ buttonText }}</span>
        </a>
      </div>
      <div v-else-if="retry">
        <a class="form-button" href="#" @click.prevent="refreshPage">
          <span>Yritä uudelleen</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { ErrorMessage } from '@/types/error-message';
import { computed } from 'vue';

// eslint-disable-next-line vue/no-unused-properties
const props = defineProps<ErrorMessage>();
const { message, buttonText, linkUrl, retry = false } = props;

const displayMessage = computed(() => {
  return props?.message?.trim() ? message : 'Hups! Sivun näyttämisessä tapahtui virhe.';
});

const refreshPage = () => {
  window.location.reload();
};

const hasHistory = () => {
  return window.history.length > 1;
};
</script>
